import { useEffect } from "react";
import { useLocation, useSearch } from "wouter";
import { useAuth } from "../lib/auth";
import { SupportWorkspace } from "../components/support/SupportWorkspace";
import { supportReturnPath } from "../lib/supportNavigation";

export default function Support() {
  const { user, loading } = useAuth();
  const [, navigate] = useLocation();
  const search = useSearch();
  useEffect(() => {
    if (!loading && !user) navigate(`/login?returnTo=${encodeURIComponent(supportReturnPath(`/support${search ? `?${search}` : ""}`) || "/support")}`);
  }, [loading, user, search, navigate]);
  if (!user) return <p className="container-x py-8" role="status">Loading Support…</p>;
  return <SupportWorkspace />;
}
